module.exports = __webpack_public_path__ + "static/73invgde-e5764203c31277b57e4b167cc7a23696.gif";